import {
  FIELD_ORDER_UI_SCHEMA_KEY,
  SECTION_NAME_UI_SCHEMA_KEY,
  ShapeUISchemaNestedShapeValues,
  SHOW_DIVIDER_LINE_KEY,
  StepConfigEditorOverride,
} from '../../StepConfigEditorTypes';
import {
  createAxisConfigGroup,
  createAxisRangeStyleSection,
  createDiscreteColorPaletteSection,
  createErrorBarsSection,
  createLegendStyleSection,
} from './ChartSchemaHelpers';

/**
 * Bar Chart configuration sections for the Configure tab
 */
export const BAR_CHART_CONFIG_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: [
    'barChartTypeSection',
    'axesSection',
    'errorBarsSection',
    'seriesAndColorPaletteSection',
  ],
  barChartTypeSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['barChartType'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    barChartType: {
      displayName: 'Type',
      configShapePath: ['chartConfig', 'parameters', 'barChartType'],
      editorOverride: StepConfigEditorOverride.ICON_SELECTOR,
      fieldSettings: {
        displayNames: {
          STANDARD: 'Standard',
          STACKED: 'Stacked',
        },
        svgImagePaths: {
          STANDARD: '/static/img/insights/grouped_bar_chart.svg',
          STACKED: '/static/img/insights/stacked_bar_chart.svg',
        },
      },
    },
  },
  axesSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['xAxisGroup', 'yAxisGroup'],
    xAxisGroup: createAxisConfigGroup('x', {includeScale: false}),
    yAxisGroup: createAxisConfigGroup('y'),
  },
  seriesAndColorPaletteSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['seriesSection', 'colorSection'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    [SECTION_NAME_UI_SCHEMA_KEY]: 'Series & Color Palette',
    seriesSection: {
      [FIELD_ORDER_UI_SCHEMA_KEY]: ['seriesColumnName'],
      seriesColumnName: {
        displayName: 'Series',
        configShapePath: ['chartConfig', 'parameters', 'seriesColumnName'],
        fieldSettings: {
          allowSelectNull: true,
          noColumnSelectedText: 'None',
        },
      },
    },
    colorSection: createDiscreteColorPaletteSection(['chartConfig', 'parameters', 'seriesColumnName']),
  },
  errorBarsSection: createErrorBarsSection(),
} as const satisfies ShapeUISchemaNestedShapeValues;

/**
 * Bar Chart style sections for the Style tab
 */
export const BAR_CHART_STYLE_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['legendSection', 'yAxisSection'],
  legendSection: createLegendStyleSection(),
  yAxisSection: createAxisRangeStyleSection('y'),
} as const satisfies ShapeUISchemaNestedShapeValues;
